import React from 'react';
import classNames from 'classnames';
import { ReactComponent as ChevronRight } from '../../../assets/icons/chevron-right.svg';

import css from './FilterListItem.module.css';
import { ReactComponent as VerifiedBadge } from '../../../assets/icons/verified-badge.svg';

/**
 * FilterListItem - A full-width clickable filter item for mobile
 *
 * @component
 * @param {Object} props
 * @param {string} props.label - The filter label
 * @param {number} props.selectedCount - Number of selected options
 * @param {string} [props.selectedLabel] - Custom label to show instead of count (e.g., price range)
 * @param {Function} props.onClick - Click handler
 * @param {string} [props.className] - Additional class names
 * @returns {JSX.Element}
 */
const FilterListItem = props => {
  const { label, selectedCount, selectedLabel, onClick, className } = props;
  const classes = classNames(css.root, className, {
    [css.selected]: selectedCount > 0,
  });

  const displayLabel = selectedLabel || (selectedCount > 0 ? `${selectedCount} selected` : null);

  return (
    <button type="button" className={classes} onClick={onClick}>
      <span className={css.content}>
        <span className={css.label}> 
          {label === 'Verification' && (
            <VerifiedBadge className={css.verifiedBadge} />
          )}{' '}
          {label}
        </span>
        {displayLabel && (
          <span className={css.selectedCount}>{displayLabel}</span>
        )}
      </span>
      <ChevronRight className={css.chevron} width={24} height={24} />
    </button>
  );
};

export default FilterListItem;

